<template>
  <img src="/svg/kreditvardig.svg" width="211" height="69" alt="Kreditvärdig">
</template>
